module.exports = __webpack_public_path__ + "static/media/emmanuel.44901721.jpg";